import { useCallback, useRef } from 'react'
import qs from 'query-string'

import { useModuleContext } from '../contexts/EventsContext'

const usePush = () => {
  //@ts-ignore
  const [{ router }, dispatch] = useModuleContext()
  const currentRouter = useRef(router.asPath)

  /**
   * Makes a URL change and updates filters Store for a particular value passed in. If value is null, it is
   * removed from URL Usually called from the onChange of the filters, to directly attack the URL
   */
  const pushChange = (value, field) => {
    // Start the spinner
    dispatch({ type: 'SET_IS_LOADING_EVENTS', payload: true })
    const filterSelectionCopy = { ...router.query }
    delete filterSelectionCopy?.slug
    if (value) {
      filterSelectionCopy[field] = value
    } else {
      delete filterSelectionCopy[field]
    }

    currentRouter.current = router.asPath
    router.push({
      pathname: '/',
      query: { ...filterSelectionCopy }
    }, `${window.location.pathname}?${qs.stringify(filterSelectionCopy)}`,
      { shallow: true })
  }

  /**
   * More radical than usePush. This one overwrites the full filters in URL, and pushes to URL accordingly
   */
  const pushFullChange = useCallback((filters) => {
    // Start the spinner
    dispatch({ type: 'SET_IS_LOADING_EVENTS', payload: true })
    const filterSelectionCopy = { ...filters }
    currentRouter.current = router.asPath
    router.push({
      pathname: '/',
      query: { ...filterSelectionCopy }
    }, `${window.location.pathname}?${qs.stringify(filterSelectionCopy)}`,
      { shallow: true })
  }, [dispatch, router])

  /**
   * Deletes all the filters. It would also accept to pass { } but then any other filters travelling would be swollen
   */
   const deleteAllFilters = useCallback(() => {
    const params = { ...router.query }
    delete params.exhibition
    delete params.virtual
    delete params.physicalEvent
    delete params.date
    delete params.endDate
    delete params.startDate
    delete params.eventTypes
    delete params.hostType
    delete params.access
    delete params.cityId
    delete params.allTypes

    pushFullChange(params)
  }, [pushFullChange, router.query])

  // Active Filters returns only the filters, without the orderBy
  // The issue is that orderBy, is another URL param. This function return only pure filters, no orderBy.
  const activeFilters = () => {
    const routerQueryCopy = { ...router.query }
    delete routerQueryCopy.orderBy
    delete routerQueryCopy.favorite
    delete routerQueryCopy.lang
    return routerQueryCopy
  }

  return {
    pushChange,
    pushFullChange,
    deleteAllFilters,
    activeFilters
  }
}

export default usePush
